import { defineComponent, PropType } from "vue";

import { COMPONENT_NAME } from "./attributes";
import { AdminCurrencyShowResponseFactory } from "@/shared/repository/modules/admin/currency/factory";
import { AdminCurrencyShowResponse } from "@/shared/repository/modules/admin/currency/repo";

export default defineComponent({
  name: COMPONENT_NAME,
  props: {
    placeholder: {
      type: String,
      required: true,
    },
    value: {
      type: Number,
      required: true,
    },
    currency: {
      type: <PropType<AdminCurrencyShowResponse>>Object,
      default: AdminCurrencyShowResponseFactory(),
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  emits: {
    "update:value": null,
  },
  data() {
    return {
      isVisible: false,
    };
  },
  methods: {
    handleInput(event: Event): void {
      let value = (<HTMLInputElement>event.target).value.replace(",", ".");

      // Ограничиваем количество знаков после точки согласно currency.precision
      if (value.includes(".")) {
        const [intPart, decPart = ""] = value.split(".");
        value = intPart + "." + decPart.slice(0, this.currency.precision);
      }

      this.$emit("update:value", Number(value));
    },
  },
});
